import { inject, Injectable } from '@angular/core';

import { Container } from 'inversify';

import { BAAS_TYPES, BarErrorDelegate, BarErrorDelegateArgs } from '@lvflanders/bar';

import { BarErrorHandlerHook, BarErrorHandlerHookArgs } from './bar-error-handler.hook';

/** Error handler hooks which uses the error delegate system of @lvflanders/bar. */
@Injectable()
export class BarErrorDelegateHandlerHook implements BarErrorHandlerHook {
    readonly #container = inject(Container);

    run(args: BarErrorHandlerHookArgs): void {
        if (!this.#container.isBound(BAAS_TYPES.BarErrorDelegate)) return;
        const delegates = this.#container.getAll<BarErrorDelegate>(BAAS_TYPES.BarErrorDelegate);

        for (const delegate of delegates) {
            const delegateArgs: BarErrorDelegateArgs = {
                handled: false,
                error: args.error
            };
            delegate.handle(delegateArgs);

            if (delegateArgs.handled) args.handled = true;

            if (args.handled) break;
        }
    }
}
